// extracted by mini-css-extract-plugin
export default {"ads":"RightSidebar_ads__tbHi-","leftSidebar":"RightSidebar_leftSidebar__t7MFg"};